import withMultiplePointsViewProps from 'viewModel/reward/loyaltyPromo/multiplePointsView/withMultiplePointsViewProps';
import MultiplePointsView from 'components/Reward/LoyaltyPromo/MultiplePointsView/MultiplePointsView';

export default withMultiplePointsViewProps(MultiplePointsView);
